import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

const newInstance1 = i18next.createInstance();

export default function i18n(locale: string) {
  void i18next
    .use(initReactI18next)
    .use({
      type: 'backend',
      read: (
        language: string,
        namespace: string,
        callback: (
          err: any | null,
          translations?: Record<string, string>,
        ) => void,
      ) => {
        return import(`./locales/messages_${locale}.json`)
          .then((translation) => {
            callback(null, translation);
          })
          .catch((error) => {
            callback(error);
          });
      },
    })
    .init({
      lng: locale,
      fallbackLng: 'en',
      keySeparator: false,
    });
  return i18next;
}
